var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovimientos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.2852V6.28516C2 5.48951 2.31607 4.72645 2.87868 4.16384C3.44129 3.60123 4.20435 3.28516 5 3.28516H7C7.79565 3.28516 8.55871 3.60123 9.12132 4.16384C9.68393 4.72645 10 5.48951 10 6.28516V18.2852C10 19.0808 9.68393 19.8439 9.12132 20.4065C8.55871 20.9691 7.79565 21.2852 7 21.2852H5C4.20435 21.2852 3.44129 20.9691 2.87868 20.4065C2.31607 19.8439 2 19.0808 2 18.2852Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.28516H18C19.0609 3.28516 20.0783 3.70658 20.8284 4.45673C21.5786 5.20687 22 6.22429 22 7.28516V17.2852C22 18.346 21.5786 19.3634 20.8284 20.1136C20.0783 20.8637 19.0609 21.2852 18 21.2852H16M10 12.2852H18M18 12.2852L15 9.28516M18 12.2852L15 15.2852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovimientos);
export default __webpack_public_path__ + "static/media/movimientos.faf209b8f2b39bd9ff94318d22df8c7a.svg";
export { ForwardRef as ReactComponent };